var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
export var Input = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: white;\n  border: 1px solid #999;\n  border-radius: 3px;\n  padding: 7px 5px;\n  width: 60px;\n  text-align: end;\n\n  &:disabled {\n    background-color: #ccc;\n    opacity: 0.5;\n  }\n"], ["\n  background-color: white;\n  border: 1px solid #999;\n  border-radius: 3px;\n  padding: 7px 5px;\n  width: 60px;\n  text-align: end;\n\n  &:disabled {\n    background-color: #ccc;\n    opacity: 0.5;\n  }\n"])));
var NumberInput = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.maxValue, maxValue = _d === void 0 ? 0 : _d, _e = _a.onChange, onChange = _e === void 0 ? any : _e, _f = _a.value, value = _f === void 0 ? 0 : _f, _g = _a.stepsCount, stepsCount = _g === void 0 ? 10 : _g, _h = _a.steps, steps = _h === void 0 ? false : _h, _j = _a.defaultValue, defaultValue = _j === void 0 ? undefined : _j;
    var changeValue = function (e) {
        var target = e.target, key = e.key, shiftKey = e.shiftKey;
        var kValue = target.value;
        var inputValue = Number(kValue.replace(/[^0-9.]/g, 0));
        if (key === 'ArrowUp' && shiftKey && steps) {
            var addStepCount = inputValue + stepsCount;
            onChange({
                target: {
                    value: addStepCount,
                    type: 'number',
                },
            });
        }
        else if (key === 'ArrowDown' && shiftKey && steps) {
            var subStepCount = inputValue - stepsCount;
            if (maxValue > subStepCount) {
                subStepCount = maxValue;
            }
            onChange({
                target: {
                    value: subStepCount,
                    type: 'number',
                },
            });
        }
        else if (key === 'ArrowDown') {
            var subStepCount = --inputValue;
            if (maxValue > subStepCount) {
                subStepCount = maxValue;
            }
            onChange({
                target: {
                    value: subStepCount,
                    type: 'number',
                },
            });
        }
        else if (key === 'ArrowUp') {
            var addStepCount = ++inputValue;
            onChange({
                target: {
                    value: addStepCount,
                    type: 'number',
                },
            });
        }
        else {
            onChange({
                target: {
                    value: inputValue,
                    type: 'number',
                },
            });
        }
    };
    var attributes = {};
    if (defaultValue) {
        attributes.defaultValue = defaultValue;
    }
    else {
        attributes.value = value !== 0 ? value : '';
    }
    return (_jsx(Input, __assign({ disabled: disabled, type: "number", style: style, onKeyUp: function (e) {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.shiftKey) {
                e.preventDefault();
            }
            changeValue(e);
        }, onKeyDown: function (e) {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.shiftKey) {
                e.preventDefault();
            }
        }, onChange: function (e) {
            changeValue(e);
        }, placeholder: value === 0 ? 0 : '' }, attributes)));
};
export default NumberInput;
var templateObject_1;
